import { common } from "./pl/common";
import { home } from "./pl/home";
import { article } from "./pl/article";

const resources = {
  pl: {
    common,
    home,
    article,
  },
};

export default resources;